export default __webpack_public_path__ + "static/media/pic_podrobnee.b3ca0ec7.webp";